module.exports = __webpack_public_path__ + "img/ring_y_i_null_0.3c6b54af.png";